import React, { useState, useEffect } from "react";

import { examSessions, examSessions1 } from "../../_helpers/exams";
import { NavBar } from "../../components/nav";


export const Stats = () => {
    const [olStats, setOlStats] = useState([]);
    const [alStats, setAlStats] = useState([]);

    const getStats = (rawArray) => {
        const invArray = rawArray.map((session) => {
            return session.invigilators;
        });
    
        const emptyArr = []
    
       for (let k = 0;k<invArray.length;k++) {
         invArray[k].forEach((elem) => {
            emptyArr.push(elem);
         })
       }
    
    
        const namesStats = emptyArr.map((nm) => {
            const repNum = emptyArr.filter((val) => val === nm).length;
            return {name: nm, sessions: repNum };
        })

        return namesStats;
    
    }

    function compare( a, b ) {
        if ( a.name < b.name ){
          return -1;
        }
        if ( a.name > b.name ){
          return 1;
        }
        return 0;
    }
      
      

    const removeDuplicate = (a) => {
        const uniqueArray = a.filter((o, index, arr) =>
            arr.findIndex(item => JSON.stringify(item) === JSON.stringify(o)) === index
        );
        const sorted = uniqueArray.sort(compare);
        return sorted;
    } 

    

    useEffect(() => {
    
     const ordStat = getStats(examSessions);
     const advStats = getStats(examSessions1);

     const uniqOrd = removeDuplicate(ordStat);
     const uniqAdv = removeDuplicate(advStats);

     setOlStats(uniqOrd);
     setAlStats(uniqAdv);
       
    },[]);

    return (
        <div className="page-body">
            <NavBar />
            <div className="stats-box">
                <div className="levels-box">
                    <div className="level-cap">ORDINARY LEVEL</div>
                    <div className="level-cap">ADVANCED LEVEL</div>
                </div>
                <div className="stats-row">
                    <div className="stats-unit">
                        <div className="unit-h">
                            <div className="stat-cap">{"Name"}</div>
                            <div className="stat-h">{"Number of sessions"}</div>
                        </div>
                        {olStats.map((stat, k) => {
                            return (
                            <div className="stat" key={k}>
                                <div className="stat-cap">{stat.name}</div>
                                <div className="stat-data">{stat.sessions}</div>
                            </div>
                            )
                        })}
                    </div>
                    <div className="stats-unit">
                        <div className="unit-h">
                            <div className="stat-cap">{"Name"}</div>
                            <div className="stat-h">{"Number of sessions"}</div>
                        </div>
                        
                        {alStats.map((stat, k) => {
                            return (
                            <div className="stat" key={k}>
                                <div className="stat-cap">{stat.name}</div>
                                <div className="stat-data">{stat.sessions}</div>
                            </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}
